
import React from "react";
import ManageHosts from "./ManageHosts";
import { IMember } from "../../../services";
import * as ReactRouterDom from "react-router-dom";
import HostSettings from "./settings/HostSettings";
import HostNotifications from "./HostNotifications";
import HostTransactions from "./analytics/HostTransactions";
import CreateTournament from "./create_tournament/CreateTournament";
import HostGeneralAnalytics from "./analytics/HostGeneralAnalytics";
import HostEarningAnalytics from "./analytics/HostEarningAnalytics";
import ManageTournament from "./manage_tournament/ManageTournament";
import RedirectWithParams from "../../shared/RedirectWithParams";

export interface HostTournamentProps {
    profile: IMember;
}

function HostTournament(props: HostTournamentProps) {

    const { profile } = props;

    return (<ReactRouterDom.Routes>
        <ReactRouterDom.Route path="/" element={<ManageHosts profile={profile} />} />
        <ReactRouterDom.Route path="/:id/notifications" element={<HostNotifications />} />
        <ReactRouterDom.Route path="/:id/settings" element={<HostSettings profile={profile} />} />
        <ReactRouterDom.Route path="/:id/analytics" element={<HostGeneralAnalytics profile={profile} />} />
        <ReactRouterDom.Route path="/:id/analytics/transactions" element={<HostTransactions profile={profile} />} />
        <ReactRouterDom.Route path="/:id/analytics/earnings" element={<HostEarningAnalytics profile={profile} />} />
        <ReactRouterDom.Route path="/:id/tournament/:tournamentId/*" element={<ManageTournament profile={profile} />} />
        <ReactRouterDom.Route path="/:id/create-tournament/:tournamentEditionId?" element={<CreateTournament profile={profile} />} />
        <ReactRouterDom.Route path="/:id/tournament/:tournamentId" element={<RedirectWithParams to={"/hosts/:id/tournament/:tournamentId/participants"} />} />
    </ReactRouterDom.Routes>);

}

export default HostTournament;
